import { Loader, LoaderOptions } from 'google-maps';
import { breakpoints } from '../components/breakpoints';

export default function initMap() {
  if ($('#map').length === 0) {
    return;
  }

  /**
   * Init map
   */
  const language = wordpress.lang == 'fr' ? 'fr-CA' : 'en';
  const loader = new Loader('AIzaSyCJTrBNacizrsxwP8oEGAoilcCnkW0dOtk', {
    language: language,
  });

  loader.load().then(function (google) {
    const SnazzyInfoWindow = require('snazzy-info-window');

    const map = new google.maps.Map(document.getElementById('map'), {
      center: {
        lat: parseFloat(belleriveMap.lat),
        lng: parseFloat(belleriveMap.lng) - 0.005, //move map slightly to the right
      },
      zoom: 16,
      styles: [
        {
          featureType: 'administrative',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#D59A73',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              color: '#F2F2F2',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#FFF8F0',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#E0E9E0',
            },
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 45,
            },
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#FADECA',
            },
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text',
          stylers: [
            {
              color: '#6C888A',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#FADECA',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#6C888A',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#F2E4D4',
            },
            {
              gamma: '1.26',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#939D9F',
            },
          ],
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            {
              color: '#E7E7E7',
            },
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#5E7C82',
            },
          ],
        },
      ],
    });

    /**
     * Start marker
     */
    const startPosition = new google.maps.LatLng(parseFloat(belleriveMap.lat), parseFloat(belleriveMap.lng));

    const startMarker = new google.maps.Marker({
      position: startPosition,
      map: map,
      icon: `${wordpress.themeurl}/../dist/images/marker-start.svg`,
      clickable: false,
    });


    if (belleriveMap.categories && belleriveMap.categories.length > 0) {

      /**
       * Display markers
       */
      let markers = [];
      let infoWindows = [];

      $.each(belleriveMap.categories, function (i, category) {
        if (category.points) {
          $.each(category.points, function (j, point) {
            const position = new google.maps.LatLng(parseFloat(point.lat), parseFloat(point.lng));

            let label = {
              text: `${markers.length + 1}`,
              fontSize: '18px',
              fontWeight: '500',
              fontFamily: 'Plus Jakarta Sans',
              color: '#20373a',
            };

            const labelActive = {
              text: `${markers.length + 1}`,
              fontSize: '18px',
              fontWeight: '500',
              fontFamily: 'Plus Jakarta Sans',
              color: '#D59A73',
            };

            const icon = {
              url: `${wordpress.themeurl}/../dist/images/marker.svg`,
              labelOrigin: { x: 23, y: 26 },
            };
            const iconActive = {
              url: `${wordpress.themeurl}/../dist/images/marker-active.svg`,
              labelOrigin: { x: 23, y: 26 },
            };

            const marker = new google.maps.Marker({
              position: position,
              map: map,
              icon: icon,
              label: label,
            });

            const infoWindow = new SnazzyInfoWindow({
              marker: marker,
              content: point.name,
              closeWhenOthersOpen: true,
              panOnOpen: false,
              showCloseButton: false,
            });

            marker.addListener('click', function () {
              //Open this infoWindow
              infoWindow.open();

              //Pan map to marker
              map.panTo(marker.getPosition());

              $.each(markers, function (index, marker) {
                marker.setZIndex(100 + index);
                marker.setIcon(icon);

                label.text = `${index + 1}`;
                marker.setLabel(label);
              });

              //Active icon
              marker.setZIndex(101 + markers.length);
              marker.setIcon(iconActive);
              marker.setLabel(labelActive);

              //Activate item in list
              const markerLat = marker.getPosition().lat();
              const markerLng = marker.getPosition().lng();
              $('.map__hover__category__point__link').removeClass('active');
              $('.map__hover__category__point__link').each(function () {
                const linkLat = parseFloat($(this).attr('data-lat'));
                const linkLng = parseFloat($(this).attr('data-lng'));
                if (linkLat === markerLat && linkLng === markerLng) {
                  $(this).addClass('active');
                }
              });
            });

            marker.category = i;

            markers.push(marker);

            infoWindows.push(infoWindow);
          });
        }
      });

      /**
       * Clicking on category, close other categories and show only these markers
       */
      $('.map__hover__category__name').click(function () {
        //Hide infowindows
        $.each(infoWindows, function (index, infoWindow) {
          infoWindow.close();
        });

        if ($(this).hasClass('active')) {
          //Closing
          $(this).removeClass('active');
          $(this).next('.map__hover__category__points').slideUp();

          //Show all markers
          $.each(markers, function (index, marker) {
            marker.setVisible(true);
          });
        } else {
          //Closing others
          $('.map__hover__category__name.active').each(function () {
            $(this).removeClass('active');
            $(this).next('.map__hover__category__points').slideUp();
          });

          //Opening this one
          $(this).addClass('active');
          $(this).next('.map__hover__category__points').slideDown();

          //Show this category's markers
          const category = parseInt($(this).attr('data-category'));
          $.each(markers, function (index, marker) {
            marker.setVisible(marker.category === category);
          });

          // //Change bounds of map to show all markers
          // const bounds = new google.maps.LatLngBounds();
          // $.each(markers, function(index, marker) {
          //   bounds.extend(marker.getPosition());
          // });

          // map.fitBounds(bounds);
        }
      });

      //Click on list activates marker
      $('.map__hover__category__point__link').click(function (e) {
        e.preventDefault();
        const linkLat = parseFloat($(this).attr('data-lat'));
        const linkLng = parseFloat($(this).attr('data-lng'));
        $.each(markers, function (index, marker) {
          const lat = marker.getPosition().lat();
          const lng = marker.getPosition().lng();

          if (linkLat === lat && linkLng === lng) {
            google.maps.event.trigger(marker, 'click');
          }
        });
      });

    }

  });
}
